module.exports = __webpack_public_path__ + "static/media/80Pie.ca567843.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/80Pie.png
// module id = 1694
// module chunks = 0 1